import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Shortcode from "./components/Shortcode";
import configureStore from "./redux/configureStore";
import { Provider as ReduxProvider } from "react-redux";
import { ChakraProvider } from "@chakra-ui/react";
import customTheme from "./theme";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
const store = configureStore();

document.addEventListener("DOMContentLoaded", function () {
  const shortcode_containers = document.querySelectorAll(
    ".wp-reactivate-shortcode"
  );

  for (let i = 0; i < shortcode_containers.length; ++i) {
    const uniqShortcodeId =
      shortcode_containers[i].getAttribute("data-object-id");
    const displayTitle = shortcode_containers[i].getAttribute("data-title");
    const displayDesc = shortcode_containers[i].getAttribute("data-desc");

    const { templateId, apiUrl, nonce } = window[uniqShortcodeId];
    // const apiUrl = `http://localhost/wordpress/wp-json`;
    // const nonce = `64059d860b`;
    // const templateId = "18d52b44-508d-43ec-ac63-83e02063a935";

    render(
      <ReduxProvider store={store}>
        <Router>
          <ChakraProvider theme={customTheme}>
            <Shortcode
              id={templateId}
              displayTitle={displayTitle}
              displayDesc={displayDesc}
              apiConfig={{ apiUrl, nonce }}
            />
          </ChakraProvider>
        </Router>
      </ReduxProvider>,
      shortcode_containers[i]
    );
  }
});
